// getRealtimeComputedData.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../resource/defaults.js';

import getOperationData from '../selector/getOperationData.js';

/**
 * Get realtime channels by feature name and object id.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} feature - realtime feature name.
 * @param {string} id - realtime target object id.
 * @return {Array<{
 *   feature: string,
 *   objectId: string,
 *   provider: string,
 *   channel: string,
 *   token: string,
 *   metadata: {
 *     type: string,
 *     channelType: string,
 *     topic: string,
 *     exp: number,
 *   },
 *   status: {
 *     status: string,
 *     reason: string,
 *     timestamp: number,
 *   },
 * }>} Return channels array.
 */
const getRealtimeChannels = createCachedSelector(
  (state, feature, id) => {
    const featureChannelObject = getOperationData(state, [
      'realtime',
      'feature',
      feature,
      id,
    ]);
    return featureChannelObject
      ? Object.keys(featureChannelObject)
      : EMPTY_ARRAY;
  },
  state => getOperationData(state, ['realtime', 'channel']),
  (channelNames, channelData = EMPTY_OBJECT) => {
    return channelNames.map(channel => channelData[channel]).filter(i => !!i);
  }
)((state, feature, id) => `${feature}:${id}`);

export { getRealtimeChannels };
